export function HubspotIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-label='HubSpot'
      role='img'
    >
      <path d='M18.164 7.93V5.085a2.085 2.085 0 1 0-2.085 0v2.843a5.955 5.955 0 0 0-2.9 1.586L6.71 5.337a2.11 2.11 0 0 0 .085-.582 2.11 2.11 0 0 0-2.11-2.11 2.11 2.11 0 0 0-2.11 2.11 2.11 2.11 0 0 0 2.11 2.11c.414 0 .8-.12 1.125-.326L12.1 10.7a5.943 5.943 0 0 0-.822 3.032 5.943 5.943 0 0 0 .876 3.08L9.91 19.058a1.87 1.87 0 0 0-.55-.086 1.878 1.878 0 0 0-1.878 1.878A1.878 1.878 0 0 0 9.36 22.73a1.878 1.878 0 0 0 1.878-1.878 1.88 1.88 0 0 0-.348-1.081l2.105-2.24a5.963 5.963 0 0 0 3.21.932 5.974 5.974 0 0 0 5.97-5.97 5.97 5.97 0 0 0-4.01-5.563zm-1.96 8.85a3.29 3.29 0 0 1-3.287-3.287 3.29 3.29 0 0 1 3.287-3.287 3.29 3.29 0 0 1 3.288 3.287 3.29 3.29 0 0 1-3.288 3.287z' />
    </svg>
  );
}
